<app-code-view [isTitle]="false" *hasAuth="['VIEW_SYSTEM_ROLE', 'VIEW_ORGANISATION_ROLE']">
  <!-- output view -->
  <!--  <h4 Ctitle>-->
  <!--    Table with expandable rows-->
  <!--    <span class="f-s-14 f-w-400 d-block">expandable rows here</span>-->
  <!--  </h4>-->
  <div output>
    <div class="table-responsive-sm">
      <table mat-table [dataSource]="dataSource">
        @for (column of displayedColumns; track column) {
          <ng-container matColumnDef="{{ column }}">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 mat-subtitle-1 f-s-14 p-x-24 p-l-0">
              {{ `RoleManagement.${column}` | localize }}
            </th>
            @if (column == 'detail') {
              <td mat-cell *matCellDef="let element" class="p-x-24 f-s-14 p-l-0">
                <button matTooltip="{{'RoleManagement.Customize' | localize}}" mat-icon-button color="info" class="mobile-hidden" (click)="openAuthorizationCodesDialog(element.id, element.name)">
                  <i-tabler name="pencil-cog"></i-tabler>
                </button>
              </td>
            }
            <td mat-cell *matCellDef="let element" class="p-x-24 f-s-14 p-l-0">
              {{ element[column] }}
            </td>
          </ng-container>
        }
        <!--        <ng-container matColumnDef="expandedDetail">-->
        <!--          <td mat-cell style="padding: 0 !important;" *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">-->
        <!--            <div [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">-->
        <!--              @if (organisationRoles) {-->
        <!--                <div-->
        <!--                  class="d-grid rounded b-1 m-b-16 p-l-15 p-r-30 p-y-15"-->
        <!--                  style="grid-template-columns: 48px 1fr 1fr 1fr auto; gap: 12px;"-->
        <!--                  *ngFor="let organisationRole of organisationRoles;">-->
        <!--                  <div class="bg-light-primary text-primary icon-48 rounded f-w-600 d-flex align-items-center justify-content-center">-->
        <!--                    {{ organisationRole.id }}-->
        <!--                  </div>-->
        <!--                  <div>-->
        <!--                    <div class="f-s-14 f-w-600 mat-subtitle-1">{{ organisationRole.name }}</div>-->
        <!--                    <div class="f-s-14">{{ organisationRole.organisation.name }}</div>-->
        <!--                  </div>-->
        <!--                  <div class="f-s-14">-->
        <!--                    {{ organisationRole.createdDate }}-->
        <!--                  </div>-->
        <!--                  <div class="f-s-14">-->
        <!--                    {{ organisationRole.updatedDate || "-" }}-->
        <!--                  </div>-->

        <!--                </div>-->
        <!--              } @else {-->
        <!--                <div>-->
        <!--                  {{"RoleManagement.NotLoaded" | localize}}-->
        <!--                </div>-->
        <!--              }-->
        <!--            </div>-->
        <!--          </td>-->
        <!--        </ng-container>-->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="example-detail-row"></tr>
      </table>
    </div>
  </div>
</app-code-view>
